import React, { useState } from "react";
import { Star, Quote, ChevronDown } from "lucide-react";
import { TESTIMONIALS } from "@/data/testimonials";

export function Testimonials({ te }) {
  const [showAllMobile, setShowAllMobile] = useState(false);
  const initialCount = 3;
  return (
    <section className="py-12 lg:py-28 bg-[#FAF6F0]" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 lg:mb-12">
          <div className="flex items-center justify-center gap-1 mb-3">
            {[1, 2, 3, 4, 5].map((i) => (
              <Star key={i} className="w-5 h-5 fill-[#E5A93D] text-[#E5A93D]" />
            ))}
          </div>
          <div className="overline mb-3">{te.testimonials.rating}</div>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl text-[#292524] leading-tight mb-2">
            {te.testimonials.title}
          </h2>
          <p className="text-[#57534E] text-base sm:text-lg">{te.testimonials.sub}</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6">
          {TESTIMONIALS.map((tm, i) => {
            const hiddenOnMobile = !showAllMobile && i >= initialCount;
            return (
              <div
                key={i}
                className={`card card-hover relative overflow-hidden ${hiddenOnMobile ? "hidden md:block" : ""}`}
                data-testid={`testimonial-${i}`}
              >
                <Quote className="absolute top-4 right-4 w-7 h-7 text-[#F2EBE1]" />
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-11 h-11 rounded-full bg-[#F2EBE1] flex items-center justify-center text-2xl flex-shrink-0">
                    {tm.flag}
                  </div>
                  <div className="min-w-0">
                    <div className="font-heading font-semibold text-[#292524] text-base leading-tight">
                      {tm.name}
                    </div>
                    <div className="text-xs text-[#78716C] mt-0.5">
                      {tm.visa} · {tm.location}
                    </div>
                  </div>
                </div>
                <div className="flex items-center gap-0.5 mb-3">
                  {[1, 2, 3, 4, 5].map((s) => (
                    <Star key={s} className="w-3.5 h-3.5 fill-[#E5A93D] text-[#E5A93D]" />
                  ))}
                </div>
                <p className="text-[#292524] text-sm leading-relaxed mb-3">&ldquo;{tm.text}&rdquo;</p>
                <div className="flex items-center justify-between pt-3 border-t border-[#F2EBE1]">
                  <span className="tag !py-1 !px-2 !text-[10px]">{tm.sector}</span>
                  <span className="text-[10px] text-[#78716C]">{tm.time}</span>
                </div>
              </div>
            );
          })}
        </div>
        {!showAllMobile && TESTIMONIALS.length > initialCount && (
          <div className="mt-6 flex justify-center md:hidden">
            <button
              onClick={() => setShowAllMobile(true)}
              className="btn-outline text-sm"
              data-testid="testimonials-see-more-btn"
            >
              See more stories ({TESTIMONIALS.length - initialCount})
              <ChevronDown className="w-4 h-4" />
            </button>
          </div>
        )}
      </div>
    </section>
  );
}
